export enum LedgerBalanceType {
  TrustControl = 'trust_control',
  BuyerAllocation = 'buyer_allocation',
  /** Per-trust-account holding balance for buyer overpayment excess, pending manual refund. */
  Refund = 'refund'
}

/**
 * Status of an inflight transaction tracked on payment_instructions.
 */
export enum LedgerInflightStatus {
  INFLIGHT = 'inflight',
  COMMITTED = 'committed',
  PARTIALLY_COMMITTED = 'partially_committed',
  VOIDED = 'voided',
  FAILED = 'failed'
}

/**
 * Direction of a transaction from trust account perspective.
 */
export enum TransactionDirection {
  CREDIT = 'credit',
  DEBIT = 'debit'
}

/**
 * Simplified transaction status for display.
 */
export enum TransactionStatus {
  INFLIGHT = 'inflight',
  APPLIED = 'applied',
  VOIDED = 'voided'
}

/**
 * Grouping dimension for transactions.
 */
export enum TransactionGroupBy {
  DATE = 'date',
  COUNTERPARTY = 'counterparty',
  PURCHASE = 'purchase',
  STATUS = 'status',
  INITIATION_METHOD = 'initiationMethod',
  DIRECTION = 'direction'
}
